import React from 'react';

import { css } from '@emotion/react';
import { CSSObject } from '@emotion/serialize';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import FunnelFooter from 'src/components/Footer/FunnelFooter';
import { FUNNEL_PATH_NAMES } from 'src/utils/constants';

import Footer from '../Footer';
import NavBarHeader from '../NavBarHeader';
import FunnelNavBarHeader from '../NavBarHeader/FunnelNavBarHeader';

interface LayoutProps {
  isShowingCart?: boolean;
  children: React.ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  isFunnelPage?: boolean;
  bottomSection?: React.ReactNode;
  cssOverrides?: CSSObject;
  contentCssOverrides?: CSSObject;
}

/**
 * Reusable Layout component.
 *
 * Should wrap most if not all pages.
 */
const Layout: React.FC<LayoutProps> = ({
  children,
  isShowingCart = false,
  bottomSection,
  isFunnelPage: isFunnelPageParam,
  hideHeader,
  hideFooter,
  cssOverrides,
  contentCssOverrides,
}) => {
  const theme = useTheme();
  const router = useRouter();
  const isFunnelPage =
    isFunnelPageParam ?? FUNNEL_PATH_NAMES.includes(router.pathname);

  // positions app header + content at top, and
  // footer at bottom of layout.
  const containerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[50],
    minHeight: '100%',
    ...cssOverrides,
  });

  return (
    <div className="app-container" css={containerStyles}>
      <div>
        {hideHeader ? null : isFunnelPage ? (
          <FunnelNavBarHeader />
        ) : (
          <NavBarHeader />
        )}
        <div
          css={{
            maxWidth: theme.breakpoints.values.contentMaxWidth,
            margin: 'auto',
            paddingBottom: '5rem',
            backgroundColor: theme.palette.grey[50],
            ...contentCssOverrides,
          }}
        >
          {children}
        </div>
      </div>
      <div>
        {bottomSection}
        {hideFooter ? null : isFunnelPage ? (
          <FunnelFooter isShowingCart={isShowingCart} />
        ) : (
          <Footer isShowingCart={isShowingCart} />
        )}
      </div>
    </div>
  );
};

export default Layout;
